export const VALIDATOR_URL = 'https://www.cian.ru/nd/validator/';
export const DEVELOPER_VALIDATOR_URL = 'https://feedteam.cian.tech/feed_validator';
